export default __webpack_public_path__ + "static/media/icon-advertise-issue.b93c538c.svg";